<template>
	<div class="cart-bar">
		<div class="container">
			<div class="row">
				<div class="col">
					<div class="d-flex justify-content-between align-items-center">
						<div class="image only-desktop">
							<div class="image" :style="'background-image:url(' + product.image.url + ')'"></div>
						</div>
						<div class="detail only-desktop">
							<h1>{{ product.name }}</h1>
							<p>{{ product.intro }}</p>
						</div>
						<div class="qty-buttons">
							<div class="btn btn-outline-secondary" @click="qtyRemove">-</div>
							<input v-model="qty" class="form-control" />
							<div class="btn btn-outline-secondary" @click="qtyAdd">+</div>
						</div>
						<div class="price"><span>U$S</span> {{ product.price }}</div>

						<div class="btn btn-primary">
							Agregar al carrito
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['product'],
	data() {
		return {
			qty: 1,
		}
	},
	methods: {
		qtyAdd() {
			this.qty++
		},
		qtyRemove() {
			if (this.qty > 1) {
				this.qty--
			}
		},
	},
}
</script>
<style scoped>
.cart-bar {
	width: 100%;
	position: fixed;
	z-index: 1500;
	bottom: 40px;
	left: 0;
	right: 0;
}
.cart-bar .container .col > div {
	background-color: #fff;
	-webkit-box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
	-moz-box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
	box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
	border-radius: 5px;
	padding: 12px;
}

.image {
	width: 68px;
	height: 68px;
	background-color: #f3f3f3;
	background-size: cover;
	border-radius: 4px;
}

.detail {
	flex-grow: 1;
	padding: 8px;
	margin-left: 8px;
}
.detail h1 {
	padding: 0px;
	font-size: 18px;
	font-weight: 600;
}

.detail p {
}

.qty-buttons {
	display: flex;
	padding: 4px 16px;
}
.qty-buttons .btn {
	height: 40px;
	border-color: #d8d8d8;
	background-color: #f1f1f1;
	font-size: 26px;
	padding: 0px 12px;
}
.qty-buttons .btn:hover {
	color: #333;
	background-color: #c2bfbf;
}
.qty-buttons .btn:first-child {
	border-radius: 4px 0px 0px 4px;
}
.qty-buttons .btn:last-child {
	border-radius: 0px 4px 4px 0px;
}
.qty-buttons input {
	width: 48px;
	text-align: center;
	height: 40px;
	border-color: #d8d8d8;
	border-radius: 0px;
}

.price {
	padding: 8px 16px;
	font-size: 24px;
	font-weight: 600;
}
.price span {
	font-size: 18px;
}

@media (min-width: 991px) {
	.price {
		font-size: 28px;
	}
	.price span {
		font-size: 22px;
	}
}
</style>
